// "Aircraft details" card of a ShareJet booking: operator | model + tail | category + seats.
import type { ReactNode } from 'react';
import { Card, Col, Descriptions, Row } from 'antd';

import type { AdminBookingDetail } from '../../api/types';
import { CATEGORY_LABELS } from '../../api/types';

export function AircraftDetailsCard({ b, extra }: { b: AdminBookingDetail; extra: ReactNode }) {
  return (
    <Card title="Aircraft details" extra={extra}>
      <Row gutter={24}>
        <Col xs={24} sm={8}>
          <Descriptions column={1} bordered size="small">
            <Descriptions.Item label="Operator">{b.aircraft.operator.name}</Descriptions.Item>
          </Descriptions>
        </Col>
        <Col xs={24} sm={8}>
          <Descriptions column={1} bordered size="small">
            <Descriptions.Item label="Model name">{b.aircraft.modelName}</Descriptions.Item>
            <Descriptions.Item label="Tail number">{b.aircraft.tailNumber || '—'}</Descriptions.Item>
          </Descriptions>
        </Col>
        <Col xs={24} sm={8}>
          <Descriptions column={1} bordered size="small">
            <Descriptions.Item label="Category">
              {CATEGORY_LABELS[b.aircraft.category] ?? b.aircraft.category}
            </Descriptions.Item>
            <Descriptions.Item label="Seats">{b.aircraft.seats}</Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
    </Card>
  );
}
